// test2346
(2346 && 0);
